import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  asset: null,
  assetList: [],
};

const route = "modules/settings/views/asset/modals/deleteAsset/redux/slice";

export const assetDeleteAsset = createAsyncThunk("manage/deleteAsset/bulkDeleteAsset", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteAsset ($ids: [Int!]) {
        result: bulkDeleteAsset (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteAsset");
    return rejectWithValue(exc);
  }
}
);


const manageAssetDeleteRedux = createSlice({
  name: "manage/asset/deleteAsset",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteAsset(state, action) {
      state.open = true;
      state.asset = action?.payload?.asset;
      state.assetList = action?.payload?.assetList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //assetDeleteAsset
    builder.addCase(assetDeleteAsset.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assetDeleteAsset.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(assetDeleteAsset.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageAssetDeleteRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteAsset } = actions;

// Export the reducer, either as a default or named export
export default reducer;